import * as Sentry from '@sentry/react';

import logger from 'js/app/loggerSingleton';

const logErrorToSentry = (error: $TSFixMe) => {
  if (typeof error === 'object' && error !== null && !(error instanceof Error)) {
    Sentry.captureException(new Error(JSON.stringify(error)));
  } else {
    Sentry.captureException(error);
  }
};

const logError = (error: $TSFixMe) => {
  logger.error(error);
  logErrorToSentry(error);
};

export default logError;
